import { DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { CloseIcon } from '@silbo/ui';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import FullHeightDialog from '../components/FullHeightDialog';
import RequestDetailsContent from '../components/RequestDetailsContent';
import { getAccommodationFromRequestQueryOptions } from '../queries/get-accommodation-from-request';
import { getRequestQueryOptions } from '../queries/get-request/get-request-query-options';

interface ArchivedRequestDetailsPageProps {
  requestId: string;
}

const ArchivedRequestDetailsPage = ({ requestId }: ArchivedRequestDetailsPageProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('bed-management');

  const { data: request } = useSuspenseQuery(getRequestQueryOptions(requestId));
  const { data: accommodation } = useQuery({
    ...getAccommodationFromRequestQueryOptions(request.request),
    enabled: request.request.status === 'ACCEPTED',
  });

  const handleClose = () => {
    navigate({ to: '/bed-management/archives' });
  };

  return (
    <FullHeightDialog open onClose={handleClose}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h2">{t('requestDetails.title')}</Typography>
          <IconButton onClick={handleClose} edge="end">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <RequestDetailsContent request={request} accommodation={accommodation} />
      </DialogContent>
    </FullHeightDialog>
  );
};

export default ArchivedRequestDetailsPage;
